let calculateDistance = event =>
  Math.sqrt(
    Math.pow(event.pointers[0].clientX - event.pointers[1].clientX, 2),
    Math.pow(event.pointers[0].clientY - event.pointers[1].clientY, 2)
  );

let calculateDistanceDifference = (event1, event2) =>
  calculateDistance(event1) - calculateDistance(event2);

let zoomIn = (distance, state, event) => {
  let {
    left,
    top,
    width,
    height,
    windowWidth,
    windowHeight,
    imageWidth,
    imageHeight
  } = state;

  let distanceOrRemaining =
    distance < imageWidth - width ? distance : imageWidth - width;

  let { x, y } = event.center;
  let horizontalRatio = x / windowWidth;
  let verticalRatio = y / windowHeight;
  let imageHeightRatio =
    (imageHeight - windowHeight) / (imageWidth - windowWidth);

  return {
    left: left + distanceOrRemaining * horizontalRatio,
    top: top + distanceOrRemaining * verticalRatio * imageHeightRatio,
    width: width + distanceOrRemaining,
    height: height + distanceOrRemaining * imageHeightRatio,
    isZoomed: true
  };
};

let zoomOut = (distance, state) => {
  let {
    left,
    top,
    width,
    height,
    windowWidth,
    windowHeight,
    imageWidth,
    imageHeight
  } = state;

  if (width + distance <= windowWidth) {
    return {
      top: 0,
      left: 0,
      width: windowWidth,
      height: windowHeight,
      isZoomed: false
    };
  }

  let horizontalRatio = left / (width - windowWidth);
  let verticalRatio = top / (height - windowHeight);
  let imageHeightRatio =
    (imageHeight - windowHeight) / (imageWidth - windowWidth);

  return {
    left: left + distance * horizontalRatio,
    top: top + distance * verticalRatio * imageHeightRatio,
    width: width + distance,
    height: height + distance * imageHeightRatio,
    isZoomed: true
  };
};

export const pinch = (state, event) => {
  let distance = calculateDistanceDifference(event, state.lastPinchEvent) * 2;

  if (distance === 0) {
    return;
  }

  if (distance > 0) {
    return zoomIn(distance, state, event);
  }

  return zoomOut(distance, state);
};

export const zoomToCenter = state => {
  let { imageWidth, imageHeight, windowWidth, windowHeight } = state;

  return {
    left: (imageWidth - windowWidth) / 2,
    top: (imageHeight - windowHeight) / 2,
    width: imageWidth,
    height: imageHeight,
    isZoomed: true
  };
};

let computeUpdatedPosition = (previous, offset, min, max) => {
  let result = previous - offset;

  if (result < min) {
    return min;
  }

  if (result > max) {
    return max;
  }

  return result;
};

export const pan = (state, event) => {
  const {
    left,
    top,
    width,
    height,
    windowWidth,
    windowHeight,
    lastPanEvent
  } = state;

  const x = lastPanEvent ? event.deltaX - lastPanEvent.deltaX : event.deltaX;
  const y = lastPanEvent ? event.deltaY - lastPanEvent.deltaY : event.deltaY;

  const updatedLeft = computeUpdatedPosition(left, x, 0, width - windowWidth);
  const updatedTop = computeUpdatedPosition(top, y, 0, height - windowHeight);

  if (height <= windowHeight) {
    return { left: updatedLeft };
  }

  if (width <= windowWidth) {
    return { top: updatedTop };
  }

  return {
    left: updatedLeft,
    top: updatedTop
  };
};
